var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class DatesGateway {
    constructor(gateway, queryFactory, mapper, clock, timeRange) {
        this.gateway = gateway;
        this.queryFactory = queryFactory;
        this.mapper = mapper;
        this.clock = clock;
        this.timeRange = timeRange;
    }
    GetDates(timezone, sportId) {
        return __awaiter(this, void 0, void 0, function* () {
            const targetDay = this.clock.getBeginningOfTodayForTimeZone(timezone);
            const request = this.queryFactory(targetDay, this.timeRange, sportId);
            const response = yield this.gateway.getSportsGroupedByDate(request);
            this.mapper.setToday(targetDay);
            return this.mapper.getDates(response, timezone);
        });
    }
}
//# sourceMappingURL=DatesGateway.js.map